import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowIosDownward } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Input, Stack, Typography } from '@lyearn/ui';

import { filterValueStyle } from '../styles';
import { FilterValueProps } from '../types';

function InputFilter(props: FilterValueProps) {
  const { t } = useTranslation();
  const { filterValue, onFilterValueChange, disabled, error, className } = props;
  const [inputVal, setInputVal] = useState(filterValue);
  useEffect(() => {
    setInputVal(filterValue);
  }, [filterValue]);

  const hasError = useMemo(
    () => error && !disabled && !filterValue,
    [disabled, error, filterValue],
  );

  return (
    <Stack
      className={cn(className ?? filterValueStyle, {
        'cursor-not-allowed': disabled,
      })}
      direction="col">
      <Input
        className={cn('w-full', { 'pointer-events-none': disabled })}
        endAdornment={
          <ArrowIosDownward
            className="arrow-ios-down h-20 w-20 flex-shrink-0"
            fillColorToken="icon-placeholder"
          />
        }
        error={hasError}
        placeholder={t('Group:Editor.Value')}
        value={inputVal}
        onBlur={(e) => onFilterValueChange(e.currentTarget.value)}
        onChange={(e) => setInputVal(e.currentTarget.value)}
      />
      {hasError ? (
        <Typography className="mt-8" color="text-text-error" variant="body-short-03">
          {t('Common:Form.Error.ValueCantBeEmpty')}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default InputFilter;
